export default __webpack_public_path__ + "static/media/dawn-warrior.50aab2a4.png";